import { render, staticRenderFns } from "./ManhTest.vue?vue&type=template&id=41c0aed3"
import script from "./ManhTest.vue?vue&type=script&lang=js"
export * from "./ManhTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41c0aed3')) {
      api.createRecord('41c0aed3', component.options)
    } else {
      api.reload('41c0aed3', component.options)
    }
    module.hot.accept("./ManhTest.vue?vue&type=template&id=41c0aed3", function () {
      api.rerender('41c0aed3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/test/ManhTest.vue"
export default component.exports